import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  linkWithPhoneNumber,
  updateEmail,
  updatePassword,
  unlink,
} from "firebase/auth";
import {
  getFirestore,
  where,
  query,
  getDocs,
  collection,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { REF } from "../../store/ref";
import { REGION } from "../ref";
import { TYPES } from "./auth.type";
import { app } from "../../config/config";

const auth = getAuth(app);
const firestore = getFirestore(app);
const functions = getFunctions(app, REGION);

// -------------------------- Snapshot --------------------------
const authSub = [];
export const snapAuth = () => (dispatch) => {
  const unSub = onAuthStateChanged(auth, () => {
    const user = auth?.currentUser;
    const isLogged = user?.uid ? true : false;
    const phone = user?.phoneNumber || null;
    getLoggedSuccess(dispatch, isLogged);
    getPhoneSuccess(dispatch, phone);
  });
  authSub.push(unSub);
};

export const unSnapAuth = () => (dispatch) => {
  authSub.forEach((subscriber) => {
    subscriber();
  });
  authSub.length = 0;
};

// -------------------------- Register --------------------------

export const registerEmailPassword =
  ({ register }, callback) =>
  (dispatch) => {
    const email = register.email;
    const password = register.password;
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (callback) {
          callback({
            status: 200,
            data: user,
          });
        }
      })
      .catch((error) => {
        let message = error.message;
        switch (error.code) {
          case "auth/email-already-in-use":
            message = "Email Already In Use";
            break;
          default:
            message = error.message;
            break;
        }
        if (callback) {
          callback({
            status: 500,
            data: message,
          });
        }
      });
  };

// -------------------------- Login --------------------------
export const logIn =
  ({ login }, callback) =>
  (dispatch) => {
    const email = login.email;
    const password = login.password;
    // const cRef = collection(firestore, REF.OWNER);
    // const c0 = where("email", "==", email);
    // const c1 = where("password", "==", password);
    // const qRef = query(cRef, c0, c1);
    // getDocs(qRef).then((snapshot) => {
    //   if (snapshot.docs.length === 0) {
    //     if (callback) {
    //       const message =
    //         "Your account doesn't have permission to access this page.";
    //       callback({
    //         status: 500,
    //         data: message,
    //       });
    //     }
    //   } else {
        signInWithEmailAndPassword(auth, email, password)
          .then(() => {
            if (callback) {
              callback();
            }
          })
          .catch((error) => {
            let message = error.message;
            switch (error.code) {
              case "auth/wrong-password":
                message = "Wrong Password";
                break;
              case "auth/user-not-found":
                message = "User Not Found";
                break;
              default:
                message = error.message;
                break;
            }
            if (callback) {
              callback({
                status: 500,
                data: message,
              });
            }
          });
      // }
    // });
  };
// -------------------------- Logout --------------------------

export const logOut = () => (dispatch) => {
  signOut(auth);
};

// -------------------------- Reset Password -----------------------------

export const resetPassword =
  ({ email }, callback) =>
  (dispatch) => {
    sendPasswordResetEmail(auth, email)
      .then((reponse) => {
        callback({
          status: 200,
        });
      })
      .catch((error) => {
        let message = error.message;
        switch (error.code) {
          case "auth/user-not-found":
            message = "User Not Found";
            break;
          default:
            message = error.message;
            break;
        }
        callback({
          status: 500,
          data: message,
        });
      });
  };

// -------------------------- Signin With Phone -----------------------------

export const linkWithPhone =
  ({ phone, verifier }, callback) =>
  (dispatch) => {
    const user = auth.currentUser;
    linkWithPhoneNumber(user, phone, verifier)
      .then((result) => {
        if (callback) {
          callback({
            status: 200,
            data: result,
          });
        }
      })
      .catch((error) => {
        callback({
          status: 500,
          data: error.message,
        });
      });
  };

export const unlinkPhone = (callback) => (dispatch) => {
  const user = auth.currentUser;
  const phoneNumber = user?.phoneNumber;
  // const provider = new PhoneAuthProvider();
  if (phoneNumber) {
    unlink(user, "phone")
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        callback({
          status: 500,
          data: error.message,
        });
      });
  } else {
    if (callback) {
      callback({
        status: 200,
      });
    }
  }
};

// -------------------------- Check Phone Status --------------------------
export const checkPhone = (callback) => (dispatch) => {
  const phone = auth.currentUser?.phoneNumber || null;
  getPhoneSuccess(dispatch, phone);
  if (callback) {
    callback();
  }
};

// -------------------------- Check Update Email --------------------------
export const checkUpdateEmail =
  ({ email, password }, callback) =>
  (dispatch) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const oldEmail = user.email;
    if (email === oldEmail) {
      callback({
        status: 500,
        data: "Same email address",
      });
      return;
    }
    signInWithEmailAndPassword(auth, oldEmail, password)
      .then(() => {
        updateEmail(user, email)
          .then(() => {
            if (callback) {
              callback({
                status: 200,
              });
            }
          })
          .catch((error) => {
            let message = error.message;
            switch (error.code) {
              case "auth/invalid-email":
                message = "Invalid Email";
                break;
              case "auth/user-disabled":
                message = "User Disabled";
                break;
              case "auth/user-not-found":
                message = "User Not Found";
                break;
              case "auth/wrong-password":
                message = "Wrong Password";
                break;
              case "auth/email-already-in-use":
                message = "Email Already In Use";
                break;
              default:
                break;
            }
            if (callback) {
              callback({
                status: 500,
                data: message,
              });
            }
          });
      })
      .catch((error) => {
        let message = error.message;
        switch (error.code) {
          case "auth/invalid-email":
            message = "Invalid Email";
            break;
          case "auth/user-disabled":
            message = "User Disabled";
            break;
          case "auth/user-not-found":
            message = "User Not Found";
            break;
          case "auth/wrong-password":
            message = "Wrong Password";
            break;
          default:
            break;
        }
        if (callback) {
          callback({
            status: 500,
            data: message,
          });
        }
      });
  };

// -------------------------- Check Update Email --------------------------
export const checkUpdatePassword =
  ({ password, oldPassword }, callback) =>
  (dispatch) => {
    const user = auth.currentUser;
    const email = user.email;
    signInWithEmailAndPassword(auth, email, oldPassword)
      .then(() => {
        updatePassword(user, password)
          .then(() => {
            if (callback) {
              callback({
                status: 200,
              });
            }
          })
          .catch((error) => {
            let message = error.message;
            switch (error.code) {
              case "auth/invalid-email":
                message = "Invalid Email";
                break;
              case "auth/user-disabled":
                message = "User Disabled";
                break;
              case "auth/user-not-found":
                message = "User Not Found";
                break;
              case "auth/wrong-password":
                message = "Wrong Password";
                break;
              case "auth/email-already-in-use":
                message = "Email Already In Use";
                break;
              default:
                break;
            }
            if (callback) {
              callback({
                status: 500,
                data: message,
              });
            }
          });
      })
      .catch((error) => {
        let message = error.message;
        switch (error.code) {
          case "auth/invalid-email":
            message = "Invalid Email";
            break;
          case "auth/user-disabled":
            message = "User Disabled";
            break;
          case "auth/user-not-found":
            message = "User Not Found";
            break;
          case "auth/wrong-password":
            message = "Wrong Password";
            break;
          default:
            break;
        }
        if (callback) {
          callback({
            status: 500,
            data: message,
          });
        }
      });
  };

// -------------------------- Dispatch --------------------------
const getLoggedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_STATUS,
    payload: data,
  });
};

const getPhoneSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_PHONE,
    payload: data,
  });
};

//---------- reset Password Accout ------------------

export const resetPasswordAccount =
  ({ email }, callback) =>
  (dispatch) => {
    const resetPassword = httpsCallable(functions, "api-auth-password-reset");
    resetPassword({ email })
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((err) => {
        if (callback) {
          callback({ status: 500, data: err?.message || "Please try again" });
        }
      });
  };
